import type { AxiosInstance } from 'axios';
import type { TranslateFn, U2000ApiErrorResult } from '../u2000Core/axios/U2000HandleApiError';

const LOGICALUNIT_URL = 'U3400';

const LogicalUnitEndpoints = {
  INITLU: `${LOGICALUNIT_URL}/initLU`,
  LAYOUT: `${LOGICALUNIT_URL}/layout`,
  MONTH_PREFERENCES: `${LOGICALUNIT_URL}/monthPreferences`,
} as const;

export type U3400TileLogicalUnitCode = 'U3401' | 'U3402' | 'U3403';

export interface U3400DashboardTile {
  code: U3400TileLogicalUnitCode;
  labelFr: string;
  labelEn: string;
  size: 'Large';
}

export interface U3400DashboardLayout {
  id: string | null;
  version: number | null;
  tiles: U3400TileLogicalUnitCode[];
}

export interface U3400DashboardLayoutUpsert {
  tiles: U3400TileLogicalUnitCode[];
  id?: string;
  version?: number;
}

export interface U3400KpiUserLuPreferenceEffective {
  id: string | null;
  version: number | null;
  logicalUnitCode: U3400TileLogicalUnitCode;
  monthsTile: number;
  monthsStandalone: number | null;
  monthsStandaloneEffective: number;
}

export interface U3400MonthPreferencesUpsert {
  logicalUnitCode: U3400TileLogicalUnitCode;
  monthsTile?: number;
  monthsStandalone?: number | null;
  id?: string;
  version?: number;
}

export interface U3400InitLU {
  launchSearch: boolean;
  hideSearch: boolean;
  nbRecordPerPage: number;
  catalogueTiles: U3400DashboardTile[];
  currentLayout: U3400DashboardLayout;
  maxTiles: number;
  monthPreferences: U3400KpiUserLuPreferenceEffective[];
}

export const doInitLU = (axios: AxiosInstance) => {
  return axios.get(LogicalUnitEndpoints.INITLU);
};

export const doGetLayout = (axios: AxiosInstance) => {
  return axios.get(LogicalUnitEndpoints.LAYOUT);
};

export const doUpdateLayout = (axios: AxiosInstance, body: U3400DashboardLayoutUpsert) => {
  return axios.put(LogicalUnitEndpoints.LAYOUT, body);
};

export const doUpsertMonthPreferences = (
  axios: AxiosInstance,
  body: U3400MonthPreferencesUpsert,
) => {
  return axios.put(LogicalUnitEndpoints.MONTH_PREFERENCES, body);
};

export function luHandleAppiError(
  t: TranslateFn,
  nameSpace: string,
  err: unknown,
  errorResult: U2000ApiErrorResult,
) {
  void err;
  if (!errorResult.genericErrors?.length) {
    errorResult.genericErrors = [
      {
        title: t('errorTitle', { ns: nameSpace }),
        text: t('errGeneric', { ns: nameSpace }),
      },
    ];
  }
  return errorResult;
}
